import { useContext, useState } from "react"
import { usePrevious } from "ahooks"
import classNames from "classnames"

import { useScale } from "@/hooks"
import { GlobalContext } from "../../context"

import cloud3Png from "../../assets/img/cloud/3.png"
import cloud3Webp from "../../assets/img/cloud/3.webp"
import cloud4Png from "../../assets/img/cloud/4.png"
import cloud4Webp from "../../assets/img/cloud/4.webp"
import cloud6Png from "../../assets/img/cloud/6.png"
import cloud6Webp from "../../assets/img/cloud/6.webp"
import cloud7Png from "../../assets/img/cloud/7.png"
import cloud7Webp from "../../assets/img/cloud/7.webp"
import cloud8Png from "../../assets/img/cloud/8.png"
import cloud8Webp from "../../assets/img/cloud/8.webp"
import cloud9Png from "../../assets/img/cloud/9.png"
import cloud9Webp from "../../assets/img/cloud/9.webp"
import cloud10Png from "../../assets/img/cloud/10.png"
import cloud10Webp from "../../assets/img/cloud/10.webp"
import cloud11Png from "../../assets/img/cloud/11.png"
import cloud11Webp from "../../assets/img/cloud/11.webp"
import cloud12Png from "../../assets/img/cloud/12.png"
import cloud12Webp from "../../assets/img/cloud/12.webp"
import cloud13Png from "../../assets/img/cloud/13.png"
import cloud13Webp from "../../assets/img/cloud/13.webp"
import cloud14Png from "../../assets/img/cloud/14.png"
import cloud14Webp from "../../assets/img/cloud/14.webp"
import cloud15Png from "../../assets/img/cloud/15.png"
import cloud15Webp from "../../assets/img/cloud/15.webp"
import styles from "./index.module.less"

const clouds = [
    {
        webp: cloud4Webp,
        png: cloud4Png,
    },
    {
        webp: cloud7Webp,
        png: cloud7Png,
    },
    {
        webp: cloud8Webp,
        png: cloud8Png,
    },
    {
        webp: cloud9Webp,
        png: cloud9Png,
    },
    {
        webp: cloud10Webp,
        png: cloud10Png,
    },
    {
        webp: cloud11Webp,
        png: cloud11Png,
    },
    {
        webp: cloud12Webp,
        png: cloud12Png,
    },
    {
        webp: cloud4Webp,
        png: cloud4Png,
    },
    {
        webp: cloud13Webp,
        png: cloud13Png,
    },
    {
        webp: cloud14Webp,
        png: cloud14Png,
    },
    {
        webp: cloud3Webp,
        png: cloud3Png,
    },
    {
        webp: cloud6Webp,
        png: cloud6Png,
    },
    {
        webp: cloud15Webp,
        png: cloud15Png,
    },
]

interface Props {
    show?: boolean
}

const Cloud: React.FC<Props> = (props) => {
    const { show } = props
    const prevShow = usePrevious(show)

    const {
        state: { fontSize },
    } = useContext(GlobalContext)
    const scale = useScale(fontSize)

    const [exited, setExited] = useState(false)

    if (exited) {
        return null
    }

    return (
        <div
            className={classNames(
                styles.cloud,
                show && styles.show,
                prevShow && !show && styles.exiting
            )}
            style={{ transform: `scale(${scale})` }}
        >
            <div
                className={styles.container}
                onTransitionEnd={() => {
                    if (prevShow && !show) {
                        setExited(true)
                    }
                }}
            >
                {clouds.map((cloud, index) => (
                    <div key={index} className={styles.cloudItem}>
                        <picture className={styles.cloudItemInner}>
                            <source srcSet={cloud.webp} type="image/webp" />
                            <img src={cloud.png} alt="cloud" />
                        </picture>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Cloud
